exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ToolbarSection {\n  float: left;\n  background-color: var(--primary-background-color);\n  border-radius: 8px;\n}\n", ""]);
